import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import PageHeader from 'src/components/page-header/page-header';
import ServicesFilters from './services-filters';
import css from './services-page.module.scss';
import Services from './services';
import { ServiceBlockFilter, ServicePageProps } from 'src/types';
import { useGetCategory } from './api/queries';
import ServiceCategoryFilter from './category-filter';
import { VETERAN_LOCATIONS } from 'src/constants/routes';

export default function ServicesPage({ pageName, className }: Readonly<ServicePageProps>) {
  const slug = useParams().slug;
  const { data: category, isPending } = useGetCategory({ name: pageName, slug });
  const [searchParams, setSearchParams] = useSearchParams();

  const [filterValues, setFilterValues] = useState<ServiceBlockFilter>({
    categoryId: category?.id,
    locationId: '',
    location: '',
    search: searchParams.get('search') ?? '',
    limit: 10,
    page: 1
  });

  const pages = { path: window.location.pathname, title: category?.name };

  function handleFiltersChange(filters: ServiceBlockFilter) {
    const nextSearchParams = new URLSearchParams(searchParams);
    const keys = ['location', 'search'];
    for (const k of keys) {
      const value = filters[k]?.toString().trim();
      value && value?.length > 0 ? nextSearchParams.set(k, value) : nextSearchParams.delete(k);
    }
    if (nextSearchParams.toString() !== searchParams.toString()) setSearchParams(nextSearchParams);
    setFilterValues({ ...filterValues, ...filters });
  }

  const servicesKey = Object.entries(filterValues).join('-');

  useEffect(() => {
    if (!category && !isPending) {
      Promise.reject(new Error('Такої сторінки не існує'));
    } else if (!filterValues.categoryId?.includes(category?.id)) {
      setFilterValues({ ...filterValues, categoryId: category?.id });
    }
  }, [category, filterValues, isPending]);

  return (
    <main className={css.servicesPage}>
      <PageHeader
        title={category?.name ?? ''}
        description={category?.description ?? ''}
        filter={
          <div className={css.filters}>
            <ServicesFilters pageName={pageName} initialFilters={filterValues} onSearch={handleFiltersChange} />
          </div>
        }
        subFilter={
          pageName !== VETERAN_LOCATIONS.title ? (
            <ServiceCategoryFilter selectedCategory={filterValues.categoryId} />
          ) : undefined
        }
      />
      {isPending && <span className={css.skeletonHeader} />}
      {!isPending && <Services key={servicesKey} filters={filterValues} className={className} pages={pages} />}
    </main>
  );
}
